







































import { Component, Vue } from "vue-property-decorator";
import { ProgramPackTexts } from "../bookings/programPackTexts";
import { TreatmentApi } from "../components/treatments/treatmentApi";
import { GuidelineApi } from "../components/guidelines/guidelineApi";
import ProgramPage from "../components/programs/ProgramPage.vue";
import TreatmentLineCard from "../components/treatments/TreatmentLineCard.vue";
import TreatmentTakeRow from "../components/treatments/TreatmentTakeRow.vue";
import TreatmentRecorder from "../components/treatments/TreatmentRecorder.vue";
import CzSegmented from "../components/cz/CzSegmented.vue";
import CzPlanRow from "../components/cz/CzPlanRow.vue";
import CzCard from "../components/cz/CzCard.vue";
import CzTitle from "../components/cz/CzTitle.vue";
import CzAccordion from "../components/cz/CzAccordion.vue";
import CzUndoBar from "../components/cz/CzUndoBar.vue";

// Today's takes by time of day, and the whole treatment: active and future lines first, the ones ended in the last 30 days folded.
@Component({ components: { ProgramPage, TreatmentLineCard, TreatmentTakeRow, TreatmentRecorder, CzCard, CzTitle, CzAccordion, CzUndoBar, CzSegmented, CzPlanRow } })
export default class TreatmentPage extends Vue {
  d: any = null;
  rows: any[] = [];
  day: string = "";
  tab: string = "day";
  busySlot: string = "";
  loaded: boolean = false;
  busy: boolean = false;
  message: string = "";
  failed: boolean = false;
  showEnded: boolean = false;

  get tabs() {
    return [
      { value: "day", label: this.$t("By time of day").toString() },
      { value: "all", label: this.$t("Whole treatment").toString() },
    ];
  }

  get current(): any[] {
    return this.d.lines.filter((l: any) => l.state !== "ended");
  }

  get unscheduled(): any {
    return { slot: "", label: this.$t("No set time").toString(), items: TreatmentApi.unscheduled(this.d.lines) };
  }

  get ended(): any[] {
    return this.d.lines.filter((l: any) => l.state === "ended");
  }

  get emptyText(): string {
    if (!this.loaded || this.failed) return "";
    return this.d && this.d.lines.length ? "" : this.$t("You have no treatment").toString();
  }

  get prescribed(): string {
    if (!this.d || !this.d.prescribedOn) return "";
    const date = new Intl.DateTimeFormat(ProgramPackTexts.culture(), { day: "numeric", month: "long" }).format(new Date(GuidelineApi.day(this.d.prescribedOn) + "T12:00:00"));
    return this.d.professional
      ? this.$t("Prescribed on {0} by {1}").toString().replace("{0}", date).replace("{1}", this.d.professional)
      : this.$t("Prescribed on {0}").toString().replace("{0}", date);
  }

  get week(): string {
    return this.$t("This week {0} of {1} takes").toString().replace("{0}", String(this.d.weekDone)).replace("{1}", String(this.d.weekTarget));
  }

  async toggle(line: any, slot: string) {
    if (this.busy) return;
    this.busy = true;
    const taken = line.takenToday.indexOf(slot) >= 0;
    const day = GuidelineApi.day(this.d.today);
    const res = await (taken ? TreatmentApi.undoLine(line.id, slot, day) : TreatmentApi.markLine(line.id, slot, day, line.version)).catch(() => null);
    this.message = !res || res.ok === false ? (res && res.errorMsg) || this.$t("It was not saved.").toString() : "";
    await this.load();
    this.busy = false;
  }

  toggleTake(row: any) {
    (this.$refs.takes as any).toggle(row, this.day);
  }

  async load() {
    const [res, today] = await Promise.all([TreatmentApi.detail().catch(() => null), TreatmentApi.today().catch(() => null)]);
    this.failed = !res || res.ok !== true || !today || today.ok !== true;
    this.d = this.failed ? null : res.model;
    this.rows = this.failed ? [] : today.model.rows;
    this.day = this.failed ? "" : GuidelineApi.day(today.model.today);
    this.loaded = true;
  }

  mounted() {
    return this.load();
  }
}
